import React from "react";
import { useAlert } from "hooks";
import { StyledAlert } from "./Alert.styled";

export const Alert: React.FC = () => {
    const { isToggled, message, type } = useAlert();

    if (!isToggled) {
        return null;
    }

    return (
        <StyledAlert variant="filled" severity={type}>
            {message}
        </StyledAlert>
    );
};
